import {Routes} from '@angular/router';
import {PraticableGuard} from "../shared/guards/praticable.guard";
import {CanGuard} from "../shared/guards/can.guard";

const Routing: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'il-mio-account',
    loadChildren: () =>
      import('../modules/il-mio-profilo/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'utenti',
    loadChildren: () =>
      import('../modules/utenti/utenti.module').then((m) => m.UtentiModule),
    canActivate: [PraticableGuard]
  },
  {
    path: 'pratiche',
    loadChildren: () =>
      import('../modules/pratiche/pratiche.module').then((m) => m.PraticheModule),
    canActivate: [PraticableGuard]
  },
  {
    path: 'account/:id',
    loadChildren: () =>
      import('../modules/account/account.module').then((m) => m.AccountModule),
    canActivate: [PraticableGuard],
  },
  //---------------------
  /*{
    path: '_builder',
    loadChildren: () =>
      import('./_builder/_builder.module').then((m) => m.BuilderModule),
  },
  {
    path: 'crafted/account',
    loadChildren: () =>
      import('../modules/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'crafted/pages/_wizards',
    loadChildren: () =>
      import('../modules/_wizards/_wizards.module').then((m) => m.WizardsModule),
  },
  {
    path: 'crafted/widgets',
    loadChildren: () =>
      import('../modules/_widgets-examples/_widgets-examples.module').then(
        (m) => m.WidgetsExamplesModule
      ),
  },
  {
    path: '_apps/chat',
    loadChildren: () =>
      import('../modules/_apps/chat/chat.module').then((m) => m.ChatModule),
  },*/
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

export {Routing};
